import React from "react";
import { Link } from "react-router-dom";
// React Bootstrap
import { Button, Container, Image, Nav, Navbar } from "react-bootstrap";
// Styled Components
import styled from "styled-components";


const CustomContainer = styled(Container)`
  max-width: 1450px;
  padding: 0;
`;

const Menu = ({ perfil, logout, config, ...props }) => {
  return (
    <Navbar bg="light" className="shadow-lg" expand="lg">
      <CustomContainer>
        <Navbar.Brand href="#">
          <Link to="/provincias">
            <Image width="175" fluid src={"/images/logoSTJ.png"} alt="logo" className="py-2 mr-3" />
          </Link>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbarScroll" />
        <Navbar.Collapse id="navbarScroll">
          <Nav className="mr-auto mx-2 my-lg-0" style={{ borderBottom: "2px solid #eceef1" }} navbarScroll>
            {perfil.accessLevel >= 10 && (
              <Link to="/direccionGeneral" className="nav-link mx-2">
                <h6 className={"text-nowrap"}>Dirección General</h6>
              </Link>
            )}
            {perfil.accessLevel >= 2 && (
              <Link to="/provincias" className="nav-link mx-2">
                <h6>Provincias</h6>
              </Link>
            )}
            {perfil.accessLevel >= 2 && (
              <Link to="/hermanas" className="nav-link mx-2">
                <h6>Hermanas</h6>
              </Link>
            )}
            {perfil.accessLevel >= 8 && (
              <>

                <Link to="/laicos" className="nav-link mx-2">
                  <h6>Laicos</h6>
                </Link>
              </>
            )}
            {perfil.accessLevel >= 10 && (
              <>
                <Link to={"/familia"} className={"nav-link mx-2"}>
                  <h6>Familia Teresiana</h6>
                </Link>

              </>
            )}
            {perfil.accessLevel >= 8 && (
              <>
                <Link to="/informes" className="nav-link mx-2">
                  <h6>Informes</h6>
                </Link>
              </>
            )}
            {/* <NavDropdown title="Link" id="navbarScrollingDropdown">
                        <NavDropdown.Item href="#action3">Action</NavDropdown.Item>
                        <NavDropdown.Item href="#action4">Another action</NavDropdown.Item>
                        <NavDropdown.Divider />
                        <NavDropdown.Item href="#action5">Something else here</NavDropdown.Item>
                    </NavDropdown> */}
          </Nav>
          <Navbar.Text>
            {/* <small>{perfil.name}</small> */}
            {(perfil.accessLevel >= 3 || config.edicionHermanas === 'true') &&
              <Button className="ml-1" variant="outline-secondary" size="sm" title="Edite su perfil de usuario">
                <Link to="/perfil" title={`Ir al perfil de ${perfil.name}`}>

                  <Image width="20" fluid src={"/images/user.png"} alt="Edite su perfil" />

                </Link>
              </Button>
            }
          </Navbar.Text>
          {perfil.accessLevel >= 10 && (
            <Button className="ml-1" variant="outline-secondary" size="sm" title="Configuración de la aplicación">
              <Link to="/configuracion" title="Configuración de la aplicación">
                <Image width="20" fluid src={"/images/config.png"} alt="configuración de base de datos" />
              </Link>
            </Button>
          )}
          <Button onClick={logout} className="ml-1" variant="outline-secondary" size="sm" title="Cerrar sesión del usuario">
            <Image width="24" fluid src={"/images/salir.png"} alt="Salir de la base de datos" />
          </Button>

        </Navbar.Collapse>
      </CustomContainer>
    </Navbar>
  );
};

export default Menu;
